import './SpinnerUA.css'

export const SpinnerUA = () => {
    
    return (
        <div className="spinner"></div>
    ) 
}